import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const FingerprintIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
}) => (
  <SvgWrapper aria-label="Fingerprint Icon" viewBox={viewBox} size={size}>
    <path
      fill={color}
      d="M2 20V4a2 2 0 0 1 2-2h3.076a.77.77 0 1 1 0 1.538H4A.462.462 0 0 0 3.538 4v16a.462.462 0 0 0 .462.462h3.076l.08.005a.77.77 0 0 1 0 1.53l-.08.004H4a2 2 0 0 1-2-2Zm18.462 0V4A.462.462 0 0 0 20 3.538h-3.077a.77.77 0 0 1 0-1.538H20a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2.001h-3.077a.77.77 0 0 1 0-1.539H20a.462.462 0 0 0 .462-.461ZM8.77 16.925v-1.231a.77.77 0 0 1 1.538 0v1.23a.77.77 0 0 1-1.538 0Zm2.46 0v-.616a.77.77 0 0 1 1.54 0v.616a.77.77 0 0 1-1.54 0Zm2.462 0v-4.308c0-1.437-.914-2.307-1.692-2.308-.778 0-1.693.871-1.693 2.308v.615a.77.77 0 0 1-1.538 0v-.615c0-1.949 1.301-3.846 3.231-3.846s3.23 1.898 3.23 3.846v4.308a.77.77 0 0 1-1.538 0Zm2.463 0v-1.231a.77.77 0 0 1 1.538 0v1.23a.77.77 0 0 1-1.538 0Zm-4.924-3.077V12a.77.77 0 0 1 1.538 0v1.847a.77.77 0 0 1-1.538 0Zm4.923-.616v-1.23c0-2.71-1.954-4.77-4.154-4.77s-4.155 2.06-4.155 4.77v4.923a.77.77 0 0 1-1.538 0V12c0-3.384 2.478-6.308 5.693-6.308 3.215 0 5.692 2.924 5.692 6.308v1.23a.77.77 0 0 1-1.538 0Z"
    />
  </SvgWrapper>
)

export default FingerprintIcon
